import clsx from 'clsx'

export default function CircleGraphic({
	theme = 'light',
	size = 'md',
	className,
}: {
	theme?: string
	size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'fill'
	width?: string
	height?: string
	className?: string
}) {
	return (
		<div
			className={clsx(
				'rounded-full flex items-center justify-center aspect-square',
				{
					sm: 'h-16 w-16',
					md: 'h-32 w-32 md:h-52 md:w-52',
					lg: 'h-48 w-48 md:h-64 md:w-64',
					xl: 'h-64 w-64 md:h-80 md:w-80',
					'2xl': 'h-80 w-80 md:h-100 md:w-100',
					fill: `h-full w-full max-w-[350px] max-h-[350px]`,
				}[size],
				{
					light: 'bg-contrast opacity-[0.04]',
					dark: 'bg-white opacity-[0.04]',
					blue: 'bg-blue',
				}[theme],
				className
			)}
		>
			<div
				className={clsx(
					{
						sm: 'h-[47px] w-[47px]',
						md: 'h-[94px] w-[94px] md:h-[156px] md:w-[156px]',
						lg: 'h-[141px] w-[141px] md:h-[185px] md:w-[185px]',
						xl: 'h-[195px] w-[195px] md:h-[234px] md:w-[234px]',
						'2xl': 'h-[240px] w-[240px] md:h-[230px] md:w-[230px]',
						fill: `h-[75%] w-[75%]`,
					}[size],
					{
						light: 'bg-white',

						dark: 'bg-contrast',
						blue: 'bg-blue-dark',
					}[theme]
				)}
			/>
		</div>
	)
}
